import { requestform } from '../../messages';
import React from 'react';
import { useExportTicketsMutation } from '../../services';
import { ExportExcelTicketRequestDto, RequestData } from '../../types';
import dayjs from 'dayjs';

type ExportExelTicketProps = {
  status: string;
  fromDate: dayjs.Dayjs;
  toDate: dayjs.Dayjs;

  requestData?: RequestData
};

const ExportExcelTicket: React.FC<ExportExelTicketProps> = ({ status, fromDate, toDate, requestData}) => {
  const dateFormat = 'DD/MM/YYYY';

  const [exportTicket] = useExportTicketsMutation();
  const exportExcelTicket = () => {
    let exportTicketRequestData: ExportExcelTicketRequestDto;
    if (requestData) {
      exportTicketRequestData = { ...requestData };
    } else {
      const modifiedStatus = status.replace(/-/g, '_');
      exportTicketRequestData = {
        fromDate: fromDate.format(dateFormat),
        toDate: toDate.format(dateFormat),
        status: modifiedStatus
      };
    }


    exportTicket(exportTicketRequestData)
      .unwrap()
      .then((res) => {
        console.log(res);
      })
      .catch();
  };

  return (
    <div className='flex justify-center space-x-4'>
      {/*<RangePicker value={[fromDate, toDate]} format={dateFormat} onChange={handleDateChange} />*/}
      <button onClick={exportExcelTicket} className='flex items-center gap-2  border p-2 rounded-lg text-white bg-[#217346]'>
        {requestform.exportExcel}
      </button>
    </div>
  );
};

export default ExportExcelTicket;
